import type { AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import { isExternalHref, isSuspiciousMenuHref } from '../../lib/links';

/**
 * CMS menü/footer bağlantısı: dış adres yeni sekmede açılır; site içi yol (`/...`) router ile açılır (2 Kasım: önceden
 * düz `<a>` idi, her menü tıklaması sayfayı baştan yüklüyordu; sayfalar parçalara bölününce bu yükleme dev'de boş ekran
 * gibi görünüyordu. `Link` ile eski sayfa, yeni sayfanın parçası gelene kadar ekranda kalır, HTML/CSS yeniden inmez).
 * `mailto:`/`tel:`/`#çapa` gibi yol olmayan adresler düz `<a>` kalır. Menü bağlantısı çizen her yer bunu kullanır
 * (navbar masaüstü/mobil/mega menü, footer).
 */
export function MenuAnchor({ href, ...rest }: Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target' | 'rel'> & { href: string }) {
  // İkinci savunma (backend `MenuHref` asıl kural): görünmez karakter / javascript: / data: içeren adres tıklanmaz.
  if (isSuspiciousMenuHref(href)) return <span className={rest.className}>{rest.children}</span>;
  if (isExternalHref(href)) return <a {...rest} href={href} target="_blank" rel="noopener noreferrer" />;
  if (href.startsWith('/') && href[1] !== '/') return <Link {...rest} to={href} />;
  return <a {...rest} href={href} />;
}
